import { TextField } from "@mui/material";
import { withStyles } from "@material-ui/core";

const styles = {
  typeNumber: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    '& input[type="number"]': {
      "-moz-appearance": "textfield",
    },
  },
};

const Input = withStyles(styles)(({ classes, ...props }) => (
  <TextField {...props} className={classes.typeNumber} />
));

export default Input;
